import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { INPUT_DATE_FORMAT } from '../../../config/helpers';
import { itinerarySideBarDayPropTypes } from '../../../propTypes';
import { accomTypes } from '../BookingFieldset/helpers';

import Icon from '../Atoms/Icon';

const propTypes = exact({
  dayText: PropTypes.string,
  itinerary: PropTypes.arrayOf(itinerarySideBarDayPropTypes).isRequired,
  title: PropTypes.string,
  maskMotorhomesAsCamping: PropTypes.bool,
  campingIcon: PropTypes.string,
});

const defaultProps = {
  dayText: 'Day',
  title: null,
  maskMotorhomesAsCamping: false,
  campingIcon: '',
};

function Itinerary(props) {
  return (
    <div className="ItineraryInline">
      {props.title && <h3 className="ItineraryInline_title">{props.title}</h3>}
      <article className="ItineraryInline_content">
        {props.itinerary.map((itineraryItem, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="ItineraryInline_item">
            <div className="ItineraryInline_day">
              {props.dayText} {itineraryItem.day}
            </div>
            <div className="ItineraryInline_date">
              {moment(itineraryItem.date).format(INPUT_DATE_FORMAT)}
            </div>
            <div className="ItineraryInline_events">
              {itineraryItem.items.map((item) => {
                const isMaskedMotorhome =
                  props.maskMotorhomesAsCamping &&
                  item.type === accomTypes.MOTORHOME &&
                  props.campingIcon;
                const iconType = isMaskedMotorhome ? props.campingIcon : item.type;
                return (
                  <div key={item.key} className="ItineraryInline_details">
                    <div className="ItineraryInline_description">{item.content}</div>
                    <div className="ItineraryInline_type">
                      {item.type && <Icon blockName="ItineraryInline_icon" id={iconType} />}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </article>
    </div>
  );
}

Itinerary.propTypes = propTypes;
Itinerary.defaultProps = defaultProps;

export default Itinerary;
